import { Injectable } from "@angular/core";
import { rate, draft, fullModel, quickQuote, CompanyCode, CompanyName, effectiveDate, expirationDate, auditFrequency, underwriterCode, BusinessName, InsuredType, yearsOfOperation, City, Line1, StateCode, StateDesc, ZipCode, ContactName, Phone1, ProducerCode, producerOfRecord, EMail, primaryState, liabMedicalExpensLmt, prodCompleteOperAggLmt, liabMedicalExpAggLmt, medicalExpensPerPerson, liabilityDeduApp, blanketRating, equipmentBreakdown, cEmpPracLiab, cEpliLimDed, cDoesLocMtf, CNoEmpMore, CNoEmpLess, cIsCyberCov, cCyberOption, cCyberCovLimit, fuelTank, enhancerEndorsement, cEnhancerPlusEndt, selfStorgFacilEnd, residCleanServCovAp, employeeDishonesty, electronicData, forgeryOrAlteration, interruptionCompOper, businessIncome, hireNonownAutoLiab, hireNonownAutoLiabCov, hireAutoNonownLiabType, hiredAutoLiabLimit, nonownedAutoLiabLmt, nonOwnedAutoLiabCov, compAndFundTranFrd, moldFungiWetDryRot, apartLosDamCusAuto, resLossDamCustAuto, contractorsEndorsement, terrorismCoverage, leadPoisoning, wantGenQstn, referenceObjectId, copyMailingAddress, description, incLmtFireDeptSc, outdoorSigns, moneyAndSecurity, empDishonestyApp, moldFungWetDryRtAp, wtrBckupSmpOvrfl, apartBuildCov, apartBldFineArtsCov, apartLosDamCusApp, apartBldLossDamLmt, apartmentBldEnd, restaurantsCov, resLosDamCusAutoAp, restEndorsement, locationId, RentalProperty, BuildingSquareFootage, ConstructionType, NumberOfEmployees, DistanceFromFireStation, DistToNearestHydrant, PublicProtFireClas, Interest, OwnerOccupiedSqFtge, cRatingBasis, YearBuilt, NumberOfUnits, NumberOccupiedByOwners, NumberLeasedToOthers, NumberVacant, IsThereABasement, PercentFinished, BldReplacementCostEst, cReconstrConstr, ResAuRepMnufcProcOcup, bldHaveAFireAlarm, fireAlarmALocalAlarm, fireAlarmACenStnAlarm, fireAlarmAHrdwrSmkDet, fireAlarmABatopSmkDet, cBurgAlarm, cBurglarLocal, cBurgCentral, bldAnyOtherProtection, BldDeadboltDoorLocks, NoOfUnitsLetterCntrl, LeadPoisonYrConst, supplLeadPoisonAppl, fuelTankApplies, dmgPremisesRentYou, dmgPremRentYouSelCov, dmgPremRentYouLimit, swimmingPool, cBusinessIncExcl, offPrmBsnsInter, windstormOrHailExcl, optionalBldgDedu, OptionalPropertyDedu, windstrmHailPrcntDed, autoIncInInsurance, spoilage, comCondUntOwner, condominComUntOwnr, lossAssessmentLmt, MiscRealPropertyLmt, lossAssessmentDed, LossAssmntSubltForDed, foodContamination, timeElement, directDamage, vacancyPermitEndors, lossPayableClauses, earthquakeCoverage, BldOwnrAndSoleOccupant, BuildingLimitInsurance, includedBlanketRating, incRebudExpFollDis, greenUpgrades, ordinanceLaw, whRoofSurfaceLoss, ltCovAcvBldRc, debrisRemAddInsEndt, ClassCode, BusinssPersonalPropLmt, AreaOccupied, ClassificationPercen, cTenanatRelExp, maintenanceFees, utlSrvcDirectDmgApp, electronicDataCovApp, intOfCompOprCovApp, incLmtAccountsRecv, incLmtDpndntProp, incLmtPaperRecord, incLmtOutdoorProp, specBppTmpAwayFrmPrm, theftLimitations, brandsAndLabels, permYardsMaintainStr, seasonalIncPercentage, spoilageCovApp, earthquakeCovApplies, condDirctLiabEndt, condLiabEndtLmt, condOffLiabEndtDeduc, medExpensExclusion, amdAggLmtInsrnPrOb, Endorsement, BusinessDesc, otherLocations, CSelectSubmission, cCompPolicy, namePriorInsurer, PriorInsPremium, ListOfPolicies, recentPolCancld, cReasons, cancelExplanation, YrsExpClass, ContractorResg, snowIceRemoval, privateDriveways, parkingLots, roadHighways, OwnerPartner, EmployeePayroll, TemporaryWorker, totalPayroll, UiSubcontractorPay, GlCertSubcntrsPay, applicantSubcontract, applicantLawsuit, remarkTradeContractors, InsuredConst, AddressConst, ContactConst, ProducerConst, BusinessOwnersConst, name, BPLocationsConst, BPInlineOBJConst, BPBuildingConst, BldgPropertyType, PropertyType, autoSprinkleredSystem, cRoof, cElectrical, cWaterHeater, cHeating, cPlumbing, leadPoisoningAppl, CCompPolicyType, BPCompanionPolicy, BPGeneralQuestionsMUConst, BPOptionalRTCCoveragesConst, BPClassificationsConst, BPBuildingCoverageConst, LosseHistory, CCompPolicyNumberRef, numberOfVeterinarian, vetProLiabPerOccLmt, vetProfLiabAggLmt, veterinarIncLmtApp, veterinarProfLiab, quotePolicy, CExtendednamedinsured1, Extendednamedinsured1, BPLossHistoryGeneralQuestionsConst, CrmProtAlmALocalAlm, CrmProtAlmACenStAlm, BPIRPMRating, ProvideBreak, StateName, BPIRPMRatingLevel, FactorType, IrpmCovUk, OverrideModifier, TotalModifier, BPIRPMOverridefactors, UnderwriterRiskConcern, RiskFactor, OverrideReason, OverrideValue, IndRiskPremiumMod, cSmallContractor, RiseToClaim, building, businessPersonalProp, classificationDesc,CBlgExtRepCc,CExtRpCcOptions } from "@app/contractor.constant";

import { OfficeRequest } from "@app/interfaces/others/office.modal";

@Injectable(
  {
    providedIn: "root",
  }
)
export class OfficeDataService {
  constructor() {}

  officeData: OfficeRequest = {
    [rate]: "Y",
    [draft]: "N",
    [fullModel]: "Y",
    [quickQuote]: "N",
    [quotePolicy]: {
      [CompanyCode]: "80",
      [CompanyName]: "MAPFRE Insurance Company",
      [effectiveDate]: "",
      [expirationDate]: "",
      [auditFrequency]: "Non-Auditable",
      [underwriterCode]: "",
      [InsuredConst]: {
        [BusinessName]: "",
        [InsuredType]: "",
        [yearsOfOperation]: "",
        [AddressConst]: {
          [City]: "",
          [Line1]: "",
          [StateCode]: "",
          [StateDesc]: "",
          [ZipCode]: "",
        },
        [ContactConst]: {
          [ContactName]: "",
          [Phone1]: "",
          [EMail]: "",
        },
        [Extendednamedinsured1]: {
          [CExtendednamedinsured1]: ""
        }
      },
      [ProducerConst]: {
        [ProducerCode]: "",
        [producerOfRecord]: "",
        [ContactConst]: {
          [ContactName]: "",
          [EMail]: "",
          [Phone1]: "",
        },
      },
      [BusinessOwnersConst]: {
        [primaryState]: "Massachusetts",
        [liabMedicalExpensLmt]: "1000000",
        [prodCompleteOperAggLmt]: "2000000",
        [liabMedicalExpAggLmt]: "2000000",
        [medicalExpensPerPerson]: "5000",
        [liabilityDeduApp]: "N",
        [blanketRating]: "N",
        [IndRiskPremiumMod]: "Y", // default value
        [equipmentBreakdown]: "Y",
        [cEmpPracLiab]: "Y",
        [cEpliLimDed]: "25000",
        [cDoesLocMtf]: "",
        [CNoEmpMore]: "",
        [CNoEmpLess]: "",
        [cIsCyberCov]: "",
        [cCyberOption]: "",
        [cCyberCovLimit]: "",
        [fuelTank]: "N",
        [CBlgExtRepCc]: "",
        [CExtRpCcOptions]: "",
        [enhancerEndorsement]: "Y",
        [cEnhancerPlusEndt]: "",
        [selfStorgFacilEnd]: "N",
        [residCleanServCovAp]: "N",
        [employeeDishonesty]: "N",
        [electronicData]: "N",
        [forgeryOrAlteration]: "N",
        [interruptionCompOper]: "N",
        [businessIncome]: "N",
        [hireNonownAutoLiab]: "",
        [hireNonownAutoLiabCov]: "",
        [hireAutoNonownLiabType]: "Both",
        [hiredAutoLiabLimit]: "",
        [nonownedAutoLiabLmt]: "",
        [nonOwnedAutoLiabCov]: "",
        [compAndFundTranFrd]: "N",
        [moldFungiWetDryRot]: "N",
        [apartLosDamCusAuto]: "N",
        [resLossDamCustAuto]: "N",
        [contractorsEndorsement]: "N", // backend default
        [terrorismCoverage]: "Y",
        [leadPoisoning]: "Y",
        [wantGenQstn]: "Y",
        [BPLocationsConst]: [{
          [referenceObjectId]: "1",
          [copyMailingAddress]: "",
          [name]: "",
          [description]: "",
          [AddressConst]: {
            [City]: "",
            [Line1]: "",
            [StateCode]: "MA",
            [StateDesc]: "Massachusetts",
            [ZipCode]: "",
            [cSmallContractor]: ""
          },
          [BPInlineOBJConst]: {
            [incLmtFireDeptSc]: "N",
            [outdoorSigns]: "N",
            [moneyAndSecurity]: "N",
            [empDishonestyApp]: "N",
            [moldFungWetDryRtAp]: "N",
            [wtrBckupSmpOvrfl]: "N",
            [apartBuildCov]: "N",
            [apartBldFineArtsCov]: "N",
            [apartLosDamCusApp]: "N",
            [apartBldLossDamLmt]: "",
            [apartmentBldEnd]: "",
            [restaurantsCov]: "N",
            [resLosDamCusAutoAp]: "",
            [restEndorsement]: "",
          },
        }],
        [BPBuildingConst]: [{
          [locationId]: "1",
          [building]: "",
          [businessPersonalProp]: "",
          [BldgPropertyType]:"",
          [PropertyType]:"",
          [RentalProperty]: "",
          [BuildingSquareFootage]: "",
          [ConstructionType]: "",
          [NumberOfEmployees]: "0", // HARDCODED FROM CONTRACTOR API CHECK WITH GOPAL
          [DistanceFromFireStation]: "",
          [DistToNearestHydrant]: "",
          [PublicProtFireClas]: "",
          [autoSprinkleredSystem]: "",
          [Interest]: "",
          [OwnerOccupiedSqFtge]: "",
          [cRatingBasis]: "",
          [YearBuilt]: "",
          [cRoof]: "",
          [cElectrical]: "",
          [cWaterHeater]: "",
          [cHeating]: "",
          [cPlumbing]: "",
          [NumberOfUnits]: "",
          [NumberOccupiedByOwners]: "",
          [NumberLeasedToOthers]: "",
          [NumberVacant]: "",
          [IsThereABasement]: "N",
          [PercentFinished]: "",
          [BldReplacementCostEst]: "",
          [cReconstrConstr]: "",
          [ResAuRepMnufcProcOcup]: "N",
          [bldHaveAFireAlarm]: "Y",
          [fireAlarmALocalAlarm]: "",
          [fireAlarmACenStnAlarm]: "",
          [fireAlarmAHrdwrSmkDet]: "",
          [fireAlarmABatopSmkDet]: "",
          [cBurgAlarm]: "",
          [CrmProtAlmALocalAlm]: "",
          [CrmProtAlmACenStAlm]: "",
          [bldAnyOtherProtection]: "",
          [BldDeadboltDoorLocks]: "Y", // backend default
          [leadPoisoningAppl]: "Y",
          [NoOfUnitsLetterCntrl]: "0", // new - HARCODED CHECK WITH GOPAL
          [LeadPoisonYrConst]: "After 1978",
          [supplLeadPoisonAppl]: "",
          [fuelTankApplies]: "N",
          [dmgPremisesRentYou]: "Y",
          [dmgPremRentYouSelCov]: "Basic",
          [dmgPremRentYouLimit]: "50000",
          [swimmingPool]: "N",
          [cBusinessIncExcl]: "N",
          [offPrmBsnsInter]: "N",
          [windstormOrHailExcl]: "N",
          [optionalBldgDedu]: "Y",
          [OptionalPropertyDedu]: "500",
          [windstrmHailPrcntDed]: "",
          [autoIncInInsurance]: "",
          [spoilage]: "N",
          [comCondUntOwner]: "",
          [condominComUntOwnr]: "",
          [lossAssessmentLmt]: "1000",
          [MiscRealPropertyLmt]: "250",
          [lossAssessmentDed]: "500",
          [LossAssmntSubltForDed]: "1050",
          [foodContamination]: "N",
          [timeElement]: "N",
          [directDamage]: "N",
          [vacancyPermitEndors]: "N",
          [lossPayableClauses]: "N",
          [earthquakeCoverage]: "N",
          [BldOwnrAndSoleOccupant]: "Y",
          [BPBuildingCoverageConst]: {
            [BuildingLimitInsurance]: "",
            [includedBlanketRating]: "N",
            [incRebudExpFollDis]: "N",
            [greenUpgrades]: "N",
            [ordinanceLaw]: "N",
            [whRoofSurfaceLoss]: "N",
            [ltCovAcvBldRc]: "N",
            [debrisRemAddInsEndt]: "N",
          },
          [BPClassificationsConst]: {
            [ClassCode]: "",
            [classificationDesc]:"",
            [BusinssPersonalPropLmt]: "",
            [AreaOccupied]: "Percentage",
            [ClassificationPercen]: "100",
            [cTenanatRelExp]: "N",
            [includedBlanketRating]: "N",
            [maintenanceFees]: "N",
            [greenUpgrades]: "N",
            [utlSrvcDirectDmgApp]: "N",
            [electronicDataCovApp]: "N",
            [intOfCompOprCovApp]: "N",
            [incLmtAccountsRecv]: "N",
            [incLmtDpndntProp]: "N",
            [incLmtPaperRecord]: "N",
            [incLmtOutdoorProp]: "N",
            [specBppTmpAwayFrmPrm]: "N",
            [theftLimitations]: "N",
            [brandsAndLabels]: "N",
            [permYardsMaintainStr]: "N",
            [seasonalIncPercentage]: "25", // backend default
            [spoilageCovApp]: "N",
            [earthquakeCovApplies]: "N",
            [condDirctLiabEndt]: "",
            [condLiabEndtLmt]: "",
            [condOffLiabEndtDeduc]: "",
            [medExpensExclusion]: "N",
            [amdAggLmtInsrnPrOb]: "Y",
            [veterinarProfLiab]: "",
            [numberOfVeterinarian]: "",
            [veterinarIncLmtApp]: "",
            [vetProLiabPerOccLmt]: "",
            [vetProfLiabAggLmt]: "",
          },
        }],
        [BPOptionalRTCCoveragesConst]: [{
          [Endorsement]: "Exclusion - Personal And Advertising Injury",
        },],
        [BPIRPMRating]: [
          {
            [ProvideBreak]: "Y", // backend default
            [StateName]: "Massachusetts", // backend default
            [BPIRPMRatingLevel]: [
              {
                [FactorType]: "Both Combined", // backend default
                [IrpmCovUk]: "MA-Both Combined-Both Combined", // backend default
                [OverrideModifier]: "",
                [TotalModifier]: "",
              },
            ],
            [BPIRPMOverridefactors]: [
              {
                [FactorType]: "", //backend default
                [UnderwriterRiskConcern]: "",
                [RiskFactor]: "",
                [OverrideReason]: "",
                [OverrideValue]: "",
                [TotalModifier]: "",
              }
            ],
          },
        ],
        [BPGeneralQuestionsMUConst]: {
          [BusinessDesc]: "",
          [otherLocations]: "",
          [CSelectSubmission]: "New Business Policy to MAPFRE",
          [BPCompanionPolicy]: {
            [CCompPolicyType]: "",
            [CCompPolicyNumberRef]: "",
          },
          [cCompPolicy]: "N",
          [namePriorInsurer]: "Other",
          [PriorInsPremium]: "0",
          [ListOfPolicies]: "",
          [recentPolCancld]: "",
          [cReasons]: "",
          [cancelExplanation]: "",
          [YrsExpClass]: "",
          [LosseHistory]: "",
          [ContractorResg]: "123456",
          [snowIceRemoval]: "N",
          [privateDriveways]: "N",
          [parkingLots]: "N",
          [roadHighways]: "N",
          [OwnerPartner]: "28600",
          [EmployeePayroll]: "",
          [TemporaryWorker]: "",
          [totalPayroll]: "",
          [UiSubcontractorPay]: "",
          [GlCertSubcntrsPay]: "",
          [applicantSubcontract]: "",
          [applicantLawsuit]: "",
          [remarkTradeContractors]: "",
          [BPLossHistoryGeneralQuestionsConst]: [],
          [RiseToClaim]: "",
        },
      },
    },
  };
}
